import { render, staticRenderFns } from "./EcomMarketplaceIcon.vue?vue&type=template&id=42430c38"
import script from "./EcomMarketplaceIcon.vue?vue&type=script&lang=js"
export * from "./EcomMarketplaceIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports